import BaseModel from '@/data/models/base/base-model';
import TypeUtils from '@/helpers/type-utils';
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(relativeTime)

export default class MeterReading extends BaseModel {

  date: Date;
  meterId: string;
  value: number;

  get fromNow(): string {
    return dayjs(this.date).fromNow();
  }

  static map(data: Partial<MeterReading>): MeterReading | null {
    if (!data) {
      return null;
    }

    const meterReading = new MeterReading();

    meterReading.date = TypeUtils.hasDateOrDefault(data.date);
    meterReading.meterId = TypeUtils.hasStringOrDefault(data.meterId);
    meterReading.value = TypeUtils.hasNumberOrDefault(data.value);

    return meterReading;
  }

}
